const appConfig = {
    apiPrefix: 'https://theappxperts.com/utara/api/index.php',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
